import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postIssueLottery = (params) => {
    return axios.post(`${backendHost}/api/admin/lottery/prize/issue`, params);
};

export {
    postIssueLottery
}